var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 40,
        "min-height": 35,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _vm._t("text-title"),
          ],
          2
        ),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _vm.entity
            ? _c("gst-pay-with-holding-detail", {
                attrs: { "gst-basis": _vm.gstBasis },
                model: {
                  value: _vm.entity,
                  callback: function ($$v) {
                    _vm.entity = $$v
                  },
                  expression: "entity",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "footer",
        {
          staticClass: "modal-card-foot",
          style: `justify-content: flex-${_vm.buttonLocation}`,
        },
        [
          _c(
            "button",
            {
              staticClass: "button is-success tooltip",
              attrs: { "data-tooltip": "Save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("Save")]
          ),
          _c(
            "button",
            {
              staticClass: "button tooltip",
              attrs: { "data-tooltip": "Cancel" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }